import _regeneratorRuntime from "/www/wwwroot/kft.ycxxkj.com/admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/www/wwwroot/kft.ycxxkj.com/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import { Message, MessageBox } from 'element-ui';
import util from '@/libs/util.js';
import router from '@/router';
import { AccountLogin } from '@api/sys.login';
export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} context
     * @param {Object} payload username {String} 用户账号
     * @param {Object} payload password {String} 密码
     * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login: function login(_ref) {
      var dispatch = _ref.dispatch;
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$username = _ref2.username,
        username = _ref2$username === void 0 ? '' : _ref2$username,
        _ref2$password = _ref2.password,
        password = _ref2$password === void 0 ? '' : _ref2$password,
        _ref2$vkey = _ref2.vkey,
        vkey = _ref2$vkey === void 0 ? '' : _ref2$vkey,
        _ref2$vValue = _ref2.vValue,
        vValue = _ref2$vValue === void 0 ? '' : _ref2$vValue,
        _ref2$timestamp = _ref2.timestamp,
        timestamp = _ref2$timestamp === void 0 ? '' : _ref2$timestamp;
      return new Promise(function (resolve, reject) {
        // 开始请求登录接口
        AccountLogin({
          username: username,
          password: password,
          vkey: vkey,
          vValue: vValue,
          timestamp: timestamp
        }).then( /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
            var schools, school_ids, current_school_id;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  if (!(res.code == 0)) {
                    _context.next = 14;
                    break;
                  }
                  console.log("logincheck res", res);
                  util.cookies.set('uuid', res.data.id);
                  util.cookies.set('token', res.data.token);
                  console.log("res.data.id", res.data.id);
                  localStorage['admin_id'] = res.data.id;

                  //设置默认学校
                  if (res.data.schools.length > 0) {
                    schools = res.data.schools;
                    school_ids = [];
                    schools.forEach(function (school) {
                      school_ids.push(school.id);
                    });
                    current_school_id = localStorage.getItem("current_school_id");
                    if (!current_school_id || school_ids.indexOf(current_school_id) === -1) {
                      localStorage.setItem("current_school_id", school_ids[0]);
                    }
                  }

                  // 设置 vuex 用户信息
                  _context.next = 9;
                  return dispatch('d2admin/user/set', {
                    name: res.data.username
                  }, {
                    root: true
                  });
                case 9:
                  _context.next = 11;
                  return dispatch('load');
                case 11:
                  // 结束
                  resolve();
                  _context.next = 15;
                  break;
                case 14:
                  // alert(res.msg);
                  // reject(res)
                  // 显示提示
                  Message({
                    message: res.msg,
                    type: 'error',
                    duration: 5 * 1000
                  });
                case 15:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref3.apply(this, arguments);
          };
        }()).catch(function (err) {
          console.log('err: ', err);
          reject(err);
        });
      });
    },
    /**
     * @description 注销用户并返回登录页面
     * @param {Object} context
     * @param {Object} payload confirm {Boolean} 是否需要确认
     */
    logout: function logout(_ref4) {
      var commit = _ref4.commit,
        dispatch = _ref4.dispatch;
      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref5$confirm = _ref5.confirm,
        confirm = _ref5$confirm === void 0 ? false : _ref5$confirm;
      /**
       * @description 注销
       */
      function logout() {
        return _logout.apply(this, arguments);
      } // 判断是否需要确认
      function _logout() {
        _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                // 删除cookie
                util.cookies.remove('token');
                util.cookies.remove('uuid');
                localStorage.removeItem('admin_id');
                // 清空 vuex 用户信息
                _context2.next = 5;
                return dispatch('d2admin/user/set', {}, {
                  root: true
                });
              case 5:
                // 跳转路由
                router.push({
                  name: 'login'
                });
              case 6:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return _logout.apply(this, arguments);
      }
      if (confirm) {
        commit('d2admin/gray/set', true, {
          root: true
        });
        MessageBox.confirm('确定要注销当前用户吗', '注销用户', {
          type: 'warning'
        }).then(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          logout();
        }).catch(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          Message({
            message: '取消注销操作'
          });
        });
      } else {
        logout();
      }
    },
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} context
     */
    load: function load(_ref6) {
      var dispatch = _ref6.dispatch;
      return new Promise( /*#__PURE__*/function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resolve) {
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return dispatch('d2admin/user/load', null, {
                  root: true
                });
              case 2:
                _context3.next = 4;
                return dispatch('d2admin/theme/load', null, {
                  root: true
                });
              case 4:
                _context3.next = 6;
                return dispatch('d2admin/transition/load', null, {
                  root: true
                });
              case 6:
                _context3.next = 8;
                return dispatch('d2admin/page/openedLoad', null, {
                  root: true
                });
              case 8:
                _context3.next = 10;
                return dispatch('d2admin/menu/asideCollapseLoad', null, {
                  root: true
                });
              case 10:
                _context3.next = 12;
                return dispatch('d2admin/size/load', null, {
                  root: true
                });
              case 12:
                _context3.next = 14;
                return dispatch('d2admin/color/load', null, {
                  root: true
                });
              case 14:
                // end
                resolve();
              case 15:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x2) {
          return _ref7.apply(this, arguments);
        };
      }());
    }
  }
};